__turbopack_context__.v({
  "blog_count": "styles-module-scss-module__P3ErUW__blog_count",
  "card_outer": "styles-module-scss-module__P3ErUW__card_outer",
  "search": "styles-module-scss-module__P3ErUW__search",
  "search_bar": "styles-module-scss-module__P3ErUW__search_bar",
  "spinner": "styles-module-scss-module__P3ErUW__spinner",
  "state_sort": "styles-module-scss-module__P3ErUW__state_sort",
  "zero_state": "styles-module-scss-module__P3ErUW__zero_state",
});
